import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastButton, ToastService } from 'src/app/services/toast/toast.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(
    private toastService: ToastService,
    private translate: TranslateService,
  ) {
  }

  public async display(
    message: string,
    color = 'primary',
    position: 'bottom' | 'middle' | 'top' = 'bottom',
    duration = 2000,
    buttons?: (string | ToastButton)[],
    cssClass?: string
  ) {
    const toast = await this.toastService.create({
      message: this.translate.instant(message),
      position,
      duration,
      color,
      cssClass,
      buttons,
    });

    toast.present();
  }
}
